import React, { useRef } from "react";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getBids } from "../../../api";
import send from "../../../images/Send.png";
import { io } from "socket.io-client";
import { api_url } from "../../../constant";
import { toast } from "react-toastify";

import LoadingCircle from "./loading";

const socket = io.connect(api_url);

function Biddnigs({ setShowBiddings, auction }) {
  const currentUser = localStorage.getItem("user_id");
  const [sending, setSending] = useState(false);
  const [bids, setBids] = useState();
  const [val, setval] = useState("");
  const { data: biddnigs, isFetching } = useQuery({
    queryKey: ["bids"],
    queryFn: () => getBids(auction.id),

    initialData: [],
    onSuccess: (data) => setBids(data),
  });
  const [newBid, setNewBid] = useState("");

  const handleChange = (e) => {
    setNewBid(e.target.value);
  };

  const sendBid = (e) => {
    setSending(true);
    socket.emit(
      "new-bid",
      {
        user_id: currentUser,
        auction_id: auction.id,
        amount: newBid,
      },
      (Response) => {
  
        if (Response.status === 400) {
          toast("لا يسمح لهذا المستخدم بالمزايدة", { type: "error" });
        }
        if (Response.status === 401) {
          toast("المبلغ أقل من أخر مزايدة", { type: "error" });
        }
        if (Response.status === 402) {
          toast("اقل فرق بين المزايدات 1000 جنية", { type: "error" });
        }
        if (Response.status === 403) {
          toast(
            `أقل مبلغ لبدأ المزايده هو ${Number(
              auction.opening_price
            ).toLocaleString("en-US")}`,
            { type: "error" }
          );
        }
        setSending(false);
      }
    );
  };

  useEffect(() => {
    socket.on(`'${auction.id}'`, (data) => {
      setSending(false);
      setNewBid("");
      setBids(data);
    });
  }, [socket]);

  return (
    <>
      <div className="">
        <div className="">
          <div className="">
            <div className=" ">
              <h1 className="text-right font-bold text-lg mb-6 ">المزايدات</h1>
            </div>

            {isFetching ? (
              <div className="text-center my-auto flex justify-center items-center mb-4 h-[10rem] ">
                <LoadingCircle />
              </div>
            ) : !bids || bids.length === 0 ? (
              <div className="text-center mb-4 font-bold h-[15rem] w-72 flex justify-center items-center mx-auto border-2 border-primary rounded-[15px] ">
                لم يقم احد بالمزايدة بعد
              </div>
            ) : (
              <div>
                <div className="my-8  w-72 mx-auto  ">
                  <div className="border-primary  border-2 py-4 rounded-[15px] ">
                    <div className="w-full flex justify-center ">
                      <div className="text-xl text-gray-400 font-bold">
                        أعلى سعر للمزايدة
                      </div>
                    </div>
                    <div className="w-full flex flex-col justify-center items-center py-1   ">
                      <p className="text-5xl font-bold text-primary my-2">
                        {bids.amount
                          ? Number(bids.amount).toLocaleString("en-US")
                          : Number(auction.opening_price).toLocaleString(
                              "en-US"
                            )}
                      </p>
                      <p className="text-gray-400 text-lg font-bold">
                        جنية سوداني
                      </p>
                    </div>
                  </div>
                  {bids.created_at && (
                    <div className="flex justify-center gap-4 my-2 items-center italic">
                      {new Date(bids.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                      <div>
                        {new Date(bids.created_at).toLocaleDateString()}
                      </div>
                      <p className="text-gray-400 text-lg font-bold">بتاريخ</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div
              className={` rounded-xl h-16  mx-auto lg:w-[40%] border-[1px] border-primary flex justify-end items-center px-3  mb-3 ${
                auction.owner === currentUser ? "hidden lg:hidden" : ""
              } `}
            >
              {sending ? (
                <div className="w-10">
                  <LoadingCircle />
                </div>
              ) : (
                <button onClick={sendBid} disabled={sending}>
                  <img src={send}></img>
                </button>
              )}

              <input
                type="number"
                dir="rtl"
                value={newBid}
                name="amount"
                placeholder="إدخل مبلغ المزايدة..."
                onChange={handleChange}
                className=" border-0 bg-transparent w-full focus:ring-0 text-gray-800 font-bold placeholder:text-base placeholder:text-gray-500 placeholder:font-medium "
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Biddnigs;
